<!-- <button mat-button (click)="navigateTo('home')">Home</button>
<button mat-button (click)="navigateTo('design')">Design</button>
<button mat-button (click)="navigateTo('homes')">Homes</button>
<button mat-button (click)="navigateTo('design-overview')">
  Design Overview
</button>
<button mat-button (click)="navigateTo('equipment')">Equipment</button>

<button *ngIf="auth.loggedIn" mat-button [matMenuTriggerFor]="adDb">
  Database
</button>
<button *ngIf="auth.loggedIn" mat-button [matMenuTriggerFor]="rater">
  Raters
</button>
<button
  *ngIf="auth.loggedIn"
  mat-button
  [matMenuTriggerFor]="builder"
  (click)="navigateTo('builder')"
>
  Builders
</button>
<button mat-button *ngIf="auth.loggedIn" (click)="auth.logout()">Logout</button>
<button mat-button (click)="auth.login()">Login</button>

<mat-menu #adDb="matMenu">
  <button mat-menu-item (click)="navigateTo('billing')">Billing</button>
  <button mat-menu-item (click)="navigateTo('cities')">Cities</button>
  <button mat-menu-item (click)="navigateTo('contacts')">Contacts</button>
  <button mat-menu-item (click)="navigateTo('customers')">Customers</button>
  <button mat-menu-item (click)="navigateTo('customerjobs')">
    Customer Jobs
  </button>
  <button mat-menu-item (click)="navigateTo('employees')">Employees</button>
  <button mat-menu-item (click)="navigateTo('jobtypes')">Job Types</button>
  <button mat-menu-item (click)="navigateTo('locations')">Locations</button>
  <button mat-menu-item (click)="navigateTo('plans')">Plans</button>
  <button mat-menu-item (click)="navigateTo('subdivision')">Subdivsions</button>
  <button mat-menu-item (click)="navigateTo('login')">Admin Schedule</button>
  <button mat-menu-item (click)="navigateTo('login')">Builder Jobs</button>
  <button mat-menu-item (click)="navigateTo('version')">Version History</button>
</mat-menu>

<mat-menu #rater="matMenu">
  <button mat-menu-item (click)="navigateTo('schedule')">Schedule</button>
  <button mat-menu-item (click)="navigateTo('visualmap')">Visual Map</button>
</mat-menu>

<mat-menu #builder="matMenu">
  <button mat-menu-item (click)="navigateTo('login')">
    Builder ES Dashboard
  </button>
</mat-menu> -->

<div *ngIf="hvacContractor == false">
  <header class="dashboard-header">
    <div class="container-fluid" id="main-nav">
      <div class="d-flex justify-content-between align-items-center">
        <div class="toggle-container">
          <button class="menu-toggle" (click)="toggleAside()">
            <i class="fa fa-solid fa-bars"></i>
          </button>
        </div>
        <span style="display:flex;" class="logo">
          <img height="55px;" width="220px;" src="../assets/images/logo.jpg" alt="">
        </span>
        <div class="d-flex align-items-center">
          <a (click)="auth.logout()" class="nav-link doorIcon" title="">
            <img width="26" src="../assets/images/logout.png" alt="">
          </a>

            <!--<img class = "doorImage" width="26" src="../assets/images/logout.png" alt="">-->
        </div>
      </div>
    </div>
  </header>

  <div class="d-flex content-container dashboard">
    <aside [ngClass]="toggleMenu ? 'active' : '' ">
      <button class="menu-toggle-close" (click)="toggleAside()">
        <i class="fa fa-times"></i>
      </button>
      <div class="user-wrapper">
        <div class="user-img">
          <img src="../assets/images/image10.png" alt="">
        </div>
        <h2 class="user-name">Hello {{ username }}!</h2>
      </div>
      <div class="menu-wrapper">
        <button mat-button class="menuButton" (click)="navigateTo('home')"><i class="fa fa-home"></i> Home</button>

        <button *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'User' || auth.role == 'TManager') " class="menuButton" mat-button
          [matMenuTriggerFor]="adDb"><i class="fa fa-solid fa-database"></i> Database</button>
        <button *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'User' || auth.role == 'TManager' || auth.role == 'Sub-C')" class="menuButton" mat-button
          [matMenuTriggerFor]="rater"><i class="fa fa-solid fa-star"></i> Raters</button>



        <button *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'User' || auth.role == 'TManager')" class="menuButton" mat-button
          (click)="navigateTo('multifamily')"><i class="fa fa-solid fa-people-roof"></i> Multi-Family</button>
          <button *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'User' || auth.role == 'TManager')" class="menuButton" mat-button
          [matMenuTriggerFor]="office"><i class="fa fa-laptop"></i> Office</button>
        <button *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'Builder' || auth.role == 'TManager')" class="menuButton" mat-button
          (click)="navigateTo('builder')"><i class="fa fa-solid fa-building"></i> Builders</button>
        <button mat-button *ngIf="auth.loggedIn" class="menuButton" (click)="auth.logout()"><i
            class="fa fa-solid fa-lock"></i> Logout</button>
        <button mat-button class="menuButton" (click)="auth.login()"><i class="fa fa-solid fa-lock-open"></i>
          Login</button>
      </div>


<!--
      <mat-menu #adDb="matMenu">
        <button mat-menu-item (click)="navigateTo('billing')">Billing</button>
        <button mat-menu-item (click)="navigateTo('cities')">Cities</button>
        <button mat-menu-item (click)="navigateTo('contacts')">Contacts</button>
        <a class="menuAnchors" [routerLink]="['/customers']" >Customers</a>
        <button mat-menu-item (click)="navigateTo('customerjobs')">Customer Jobs</button>
        <button mat-menu-item (click)="navigateTo('employees')">Employees</button>
        <button mat-menu-item (click)="navigateTo('jobtypes')">Job Types</button>
        <button mat-menu-item (click)="navigateTo('locations')">Locations</button>
        <button mat-menu-item (click)="navigateTo('plans')">Plans</button>
        <button mat-menu-item (click)="navigateTo('subdivision')">Subdivsions</button>
        <button mat-menu-item (click)="navigateTo('login')">Admin Schedule</button>
        <button mat-menu-item (click)="navigateTo('login')">Builder Jobs</button>
        <button mat-menu-item (click)="navigateTo('version')">Version History</button>

      </mat-menu>

  -->

  <mat-menu #adDb="matMenu">
    <div class="menuClass">
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/billing']">Billing</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/cities']">Cities</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/contacts']">Contacts</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/customers']" >Customers</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/customerjobs']">Customer Jobs</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/employees']">Employees</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/jobtypes']">Job Types</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/locations']">Locations</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/plans']">Plans</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/subdivisions']">Subdivsions</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/login']">Admin Schedule</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/login']">Builder Jobs</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/csvreports']">CSV Reports</a>
      <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/indivaudits']">Audit Data</a>

    </div>

  </mat-menu>

      <mat-menu #rater="matMenu">
        <div class="menuClass">
        <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/schedule']">Schedule</a>
        <a  *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'TManager')" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/timetracking']">Time Tracking</a>
        <a *ngIf="auth.loggedIn" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/timeadjustments']">Time Adjustments</a>
        <a *ngIf="auth.loggedIn" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/onourwaylog']">On Our Way Log</a>
        <a *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'TManager' || auth.role == 'User')" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/training']">Training Dashboard</a>
        </div>
      </mat-menu>


      <!--
      <mat-menu #rater="matMenu">
        <div class="menuClass">

        <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/schedule']">Schedule</a>
        <a  *ngIf="auth.loggedIn" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/timetracking']">Time Tracking</a>
        <a *ngIf="auth.loggedIn" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/onourwaylog']">On Our Way Log</a>
        </div>
      </mat-menu>
-->

      <mat-menu #office="matMenu">
        <div class="menuClass">
        <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/officesched']">Office Schedule</a>
        <a *ngIf="auth.loggedIn" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/onourwaylog']">On Our Way Log</a>
        <a *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'TManager' || auth.role == 'User')" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/builderconfirmations']">Builder Confirmations</a>
        <a  *ngIf="auth.loggedIn && (auth.role == 'Admin' || auth.role == 'TManager' )" (click)="toggleAside()" class="menuAnchors" [routerLink]="['/timetracking']">Time Tracking</a>
        </div>
      </mat-menu>

      <mat-menu #builder="matMenu">
        <!-- <button mat-menu-item (click)="navigateTo('login')">Builder ES Dashboard</button> -->
        <a (click)="toggleAside()" class="menuAnchors" [routerLink]="['/estar']">Builder Dashboard</a>
      </mat-menu>
    </aside>

    <div class="content-wrapper" style="overflow-x:auto">

      <!--
      <ul class="breadgrums">
        <li>Home</li>
        <li>Schedule</li>
      </ul>
-->
      <router-outlet></router-outlet>
    </div>


  </div>

</div>

<div *ngIf="hvacContractor == true">
  <header *ngIf="auth.loggedIn">
    <div class="container-fluid" id="main-nav">
      <div class="d-flex justify-content-between align-items-center">
        <a routerLink="/home" class="logo">
          <img src="../assets/images/logo.jpg" alt="">
        </a>
        <div class="d-flex align-items-center">
          <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item">
                    <a class="nav-link " aria-current="page" (click)="setRoute='parent'"
                      [ngClass]="{'nav-link__active':setRoute == 'parent'}" routerLinkActive='nav-link__active'
                      routerLink="/home">Home</a>
                  </li>
                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" [ngClass]="{'nav-link__active':setRoute == 'parent1'}"
                      id="navbarDropdown" routerLinkActive='nav-link__active' role="button" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      Equipment
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li><a class="dropdown-item" (click)="setRoute='parent1'" routerLinkActive='nav-link__active'
                          routerLink="/equipment">Equipment</a></li>
                      <li><a class="dropdown-item" (click)="setRoute='parent1'" routerLinkActive='nav-link__active'
                          routerLink="/equipment-form">New
                          Equipment</a></li>
                    </ul>
                  </li>

                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" [ngClass]="{'nav-link__active':setRoute == 'parent3'}"
                      id="navbarDropdown" role="button" routerLinkActive='nav-link__active' data-bs-toggle="dropdown"
                      aria-expanded="false">
                      Designs
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li><a class="dropdown-item" (click)="setRoute='parent3'" routerLinkActive='nav-link__active'
                          routerLink="/design">My Designs</a>
                      </li>
                      <li><a class="dropdown-item" (click)="setRoute='parent3'" routerLinkActive='nav-link__active'
                          routerLink="/design-form">New
                          Design</a></li>
                    </ul>
                  </li>

                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" [ngClass]="{'nav-link__active':setRoute == 'parent2'}"
                      routerLinkActive='nav-link__active' id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      Systems
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li><a routerLinkActive='nav-link__active' (click)="setRoute='parent2'" routerLink="/system"
                          class="dropdown-item">My Systems</a>
                      </li>
                      <li><a routerLinkActive='nav-link__active' (click)="setRoute='parent2'" routerLink="/new-system"
                          class="dropdown-item">New
                          System</a></li>
                    </ul>
                  </li>



                  <!-- <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" routerLinkActive='nav-link__active' id="navbarDropdown"
                    role="button" data-bs-toggle="dropdown" aria-expanded="false" routerLink="/locations">
                    Locations
                  </a>
                  <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a class="dropdown-item" routerLinkActive='nav-link__active' routerLink="/location">View
                        Houses</a></li>
                  </ul>
                </li> -->
                  <li class="nav-item">
                    <a class="nav-link" (click)="setRoute='parent4'"
                      [ngClass]="{'nav-link__active':setRoute == 'parent4'}" routerLinkActive='nav-link__active'
                      id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"
                      routerLink="/hvacLocations">
                      Locations
                    </a>
                  </li>

                  <li class="nav-item">
                    <a (click)="auth.logout()" class="nav-link" title="">
                      <img width="26" src="../assets/images/logout.png" alt="">
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>


        </div>

      </div>

    </div>

  </header>

</div>
  <router-outlet style="overflow-x:auto"></router-outlet>





